import React from 'react';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import './Presentacion.css';
import Imagenes from '../../provider/carga/imagenes/Imagenes';
import audioFondo1 from '../../audios/StairwayPatrickPatrikios.mp3';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

class Presentacion extends React.Component {
    constructor(...args) {
        super(...args);
    
        this.state = {
            textPlay: '',
            lastTextPlay: '',
            playButton: false,
            listaTexto: [
                'Hola bienvenido y bienvenidas al canal de noticias, de ultimo momento donde contaremos con las ultimas noticias de tecnologia, informacion de ultimo momento con novedades ',
                'ECLLPSE se presenta como una unidad de almacenamiento portátil revolucionaria que permite una transferencia de datos rápida y sin complicaciones, así como una copia de seguridad de datos sobre la marcha.',
                'tendremos las mejores noticias',
                'ultimo datos online'
            ],
            textoActual: 0,
            hablando: false,
            altoPersona: '100vh',
            fondo: '',
            fondoTransform: 'scale(1)',
            fondoFilter: '',
            fondoTranslate: 'translate(0px, 0px)',
            subtitulos: '',
            subtitulos2: '',
            fullScreen: false,
            fondoSubtitulos: false
        };
        this.playVoz = this.playVoz.bind(this);
        this.error = this.error.bind(this);
        this.iniciar = this.iniciar.bind(this);
        this.pausar = this.pausar.bind(this);
        this.end = this.end.bind(this);
        this.start = this.start.bind(this);
        this.cambiarTexto = this.cambiarTexto.bind(this);
        this.cargarImagen = this.cargarImagen.bind(this);
        this.toggleFullScreen = this.toggleFullScreen.bind(this);
        this.cargarDatos = this.cargarDatos.bind(this);
      }
    componentDidMount() {
        this.iniciar();
    }      
    playVoz(texto,inicial) {
        if(!texto) {
            return false;
        }
        if (inicial){
            //paro todo lo que se dice
            window.speechSynthesis.cancel();
            let musica = document.getElementById('musica');
            musica.volume = 0.01;
            musica.play();
        }
        let imagen = new Imagenes();
        imagen.buscar(texto,this.cargarImagen);
        this.cargarSubtitulo(texto);
        let mensaje = new SpeechSynthesisUtterance();
        let flexibilixar = Number((Math.random() * (0.100 - 0.0000) + 0.0000).toFixed(2));
        let flexibilixar2 = Number((Math.random() * (0.200 - 0.0000) + 0.0000).toFixed(2));
        let rate = 1.10 + flexibilixar;
        let pitch = 1.05 + flexibilixar2;
        mensaje.rate = rate;
        mensaje.text = texto;
        mensaje.pitch = pitch;
        mensaje.onerror = this.error;
        mensaje.onend = this.end;
        mensaje.onstart = this.start;
        this.setState({lastTextPlay:texto});
        speechSynthesis.speak(mensaje);
    } 
    cargarImagen(src) {
        if (src) {
            let { fondoFilter , fondoTransform, fondoTranslate, fondoSubtitulos } = this.state;
            switch (Math.floor(Math.random() * 4)) {
                case 0:
                    fondoFilter = 'blur(3px)';
                    break;
                case 1:
                    fondoTransform = 'scale(1.5)';
                    break;
                case 2:
                    fondoTranslate = 'translate(0px, -20%)';
                    break;
                case 3:
                    fondoSubtitulos = true;
                    break;    
                default:
                    break;
            }
            this.setState({
                fondo:`url('${src}')`,
                fondoTransform: fondoTransform + '' + fondoTranslate,
                fondoFilter: fondoFilter,
                fondoSubtitulos: fondoSubtitulos
            });
        }
    }
    cargarDatos(json) {
        if (json && json.data && json.data.noticia[0]) {
            let textos = JSON.parse(json.data.noticia[0].texto);
            textos = this.validarTextos(textos);
            this.setState({listaTexto: textos});
        } else { console.log('no se pudo cargar')}
        
        if (speechSynthesis.paused) {
            speechSynthesis.resume();
        } else {
            this.playVoz(this.cambiarTexto(), true);
        }
    }
    validarTextos(texto) {
        let result = '';
        let listaTexto = [];
        for (const linea of texto) {
            result = result + ' ' + linea;
        }
        let palabras = result.split(" ");
        let i = 0, total = 0;
        let linea = '';
        for (const key in palabras) {
            i++;
            total++;
            linea = linea + ' ' + palabras[key];
            if (i >= 30) {
                listaTexto.push(linea);
                i = 0;
                linea = '';
            } else if (palabras.length === total) {
                listaTexto.push(linea);
            } else {

            }
        }
        console.log(listaTexto);
        return listaTexto;
    }
    iniciar() {
        this.setState({playButton: false});
        let _this = this;
        //let datos = new Datos();
        //datos.buscar(this.props.match.params.id,this.cargarDatos);
        if (!(window.webkitSpeechRecognition)) {
            alert("¡API no soportada!");
          } else {
            var recognition = new window.webkitSpeechRecognition();
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.lang = "es-Ve";
          
            recognition.onstart = function() {console.log('inicio')}
            /*recognition.onresult = function(event) {
                console.log(event);
                for (var i = event.resultIndex; i < event.results.length; i++) {
                    if(event.results[i]){
                        if (_this.state.lastTextPlay !== event.results[i][0].transcript) {
                            var texto = _this.state.subtitulos += event.results[i][0].transcript;
                            _this.cargarSubtitulo(texto, true);
                            _this.setState({lastTextPlay: event.results[i][0].transcript});
                        }

                    }
                }
            }*/
            //var COMMANDS = new generateTranscriptionCommands("es-VE");
            var listActionCommands = [];
            var listToReplaceCommands = [];
            var listToReplaceMarks = [];
            var listBreakCommands = [];
            let str = "";
            recognition.onresult = function(c) {
                console.log("Fired onresult");
                if (typeof(c.results) === "undefined") {
                    recognition.onend = null;
                    //variables.intentionalPause = true;
                    recognition.stop();
                    //upgrade();//start_button.style.visibility = "hidden";
                    return
                }
                //$("#mirror").fadeIn("fast");
                //mirror.innerHTML = "";
                str = "";
                for (var b = c.resultIndex; b < c.results.length; ++b) {
                    str = c.results[b][0].transcript;
                    if (!(str.substring(0, 2) === "I ")) {
                        str = str[0].toLowerCase() + str.substring(1, str.length)
                    }
                    if (c.results[b].isFinal) {
                        console.log(" --- Final result= " + str);
                        switch (listActionCommands.indexOf(str)) {
                            case 0:
                                return;
                            default:
                                break
                        }
                        for (var a = 0; a < listToReplaceCommands.length; a++) {
                            str = str.replace(listToReplaceCommands[a], listToReplaceMarks[a])
                        }
                        //$("#mirror").fadeOut("slow");
                        //insertText(str)
                        _this.cargarSubtitulo(str, true);
                        _this.cargarSubtitulo2("", true);
                        let imagen = new Imagenes();
                        imagen.buscar(str,_this.cargarImagen);
                        _this.setState({hablando: false});
                    } else {
                        _this.cargarSubtitulo2(c.results[b][0].transcript, true);
                        _this.setState({hablando: true});
                        //console.log(" ----- Interim result= " + c.results[b][0].transcript);
                        str = " " + str;
                        for (var t = 0; t < listBreakCommands.length; t++) {
                            if (str.indexOf(listBreakCommands[t]) !== (-1)) {
                                //startButton(c);
                                //isToRestartImmediately = true;
                                return
                            }
                        }
                    }
                }
            }

            recognition.onerror = function(event) {console.log(event)}
            recognition.onend = function() {
                console.log('fin');
                _this.setState({playButton: true});
            }
            recognition.start();
        }
    } 
    pausar() {
        this.setState({playButton: true});
        speechSynthesis.pause();
    }
    error(evento) {
        console.error('A ocurrido un error con sistesis de voz: ' + evento.error);
        switch (evento.error) {
            case 'not-allowed':
                this.setState({playButton: true});
                break;
        
            default:
                break;
        }
    }
    cambiarTexto() {
        let actual = this.state.textoActual;
        if (this.state.listaTexto.length > actual) {
            this.setState({
                textPlay:this.state.listaTexto[actual],
                textoActual: actual + 1
            });
        } else {
            actual = actual - 1;
            this.setState({
                textPlay:this.state.listaTexto[actual],
                textoActual: actual
            });
        }
        if (this.state.listaTexto.length  === actual ) {
            window.speechSynthesis.cancel();
        }
        return this.state.listaTexto[actual];
    }
    start(evento) {
        this.setState({hablando: true, playButton: false});
    }
    end(evento) {
        this.setState({hablando: false});
        console.log('Fin sistesis de voz: ' );
        console.log(evento);
        this.setState({
            playButton: true,
            fondoTransform:'scale(1)',
            fondoFilter: '',
            fondoTranslate: 'translate(0px, 0px)',
            fondoSubtitulos: false
        });
        this.cambiarTexto();
        if (this.state.lastTextPlay !== this.state.textPlay) {          
            this.playVoz(this.state.textPlay);
        } else {
            let musica = document.getElementById('musica');
            musica.pause();
        }
    }
    cargarSubtitulo(texto,activo) {
        if (activo) {
            this.setState({subtitulos: texto, fondoSubtitulos: true});
        } else {
            this.setState({subtitulos:texto});
        }
    }
    cargarSubtitulo2(texto,activo) {
        if (activo) {
            this.setState({subtitulos2: texto, fondoSubtitulos: true});
        } else {
            this.setState({subtitulos2:texto});
        }
    }
    toggleFullScreen() {
        if (!document.fullscreenElement &&    // alternative standard method
                !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                        document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
                this.setState({fullScreen: true});
        } 
        else {
                if (document.exitFullscreen) {
                        document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                }
                this.setState({fullScreen: false});
        }
}
    render() {
        return(
            /*
               <div className="persona">
                        {this.state.hablando && <img src={persona} alt="Animated:" style={{height:this.state.altoPersona}}/>}
                        {!this.state.hablando && <img src={personaPausada} alt="Static:" style={{height:this.state.altoPersona}}/>}
                </div>
                 */
            <div className="canal">
                <div className="contenido" style={{
                    backgroundImage:this.state.fondo,
                    transform: this.state.fondoTransform,
                    filter: this.state.fondoFilter
                    }}>
                </div>
                <div className="subtitulos">
                    {this.state.fondoSubtitulos && <p>{this.state.subtitulos}</p>}
                    {this.state.fondoSubtitulos && <p>{this.state.subtitulos2}</p>}
                </div>
                <div>
                    <audio id="musica" loop={true}>
                        <source src={audioFondo1} type="audio/mpeg"/>
                    </audio>
                </div>
                <div className="barra">
                    {this.state.playButton && <PlayCircleFilledIcon className="play" onClick={this.iniciar} ></PlayCircleFilledIcon>}
                    {!this.state.playButton && <PauseCircleFilledIcon className="play" onClick={this.pausar} ></PauseCircleFilledIcon>}
                    {!this.state.fullScreen && <FullscreenIcon className="screen" onClick={this.toggleFullScreen} ></FullscreenIcon>}
                    {this.state.fullScreen && <FullscreenExitIcon className="screen" onClick={this.toggleFullScreen} ></FullscreenExitIcon>}
                
                </div>
            </div>
        );
    }
}

export default Presentacion;